/*eslint-disable*/ export const messages = JSON.parse("{\"select.label.optional\":[\"Optional\"]}");
//# sourceMappingURL=messages.mjs.map